import React from 'react'

import { cn } from '@/lib/utils'
import { getBranchCurrency } from '@/lib/currency'
import { formatCurrency } from '@/lib/format'

interface CurrencyAmountProps {
  amount: number
  className?: string
  iconClassName?: string
  textClassName?: string
}

/**
 * Displays a currency amount using the selected branch currency.
 * SAR uses the Riyal SVG; other currencies use the formatted symbol.
 */
export const CurrencyAmount: React.FC<CurrencyAmountProps> = ({
  amount,
  className,
  iconClassName,
  textClassName,
}) => {
  const currency = getBranchCurrency()

  if (currency === 'SAR') {
    return (
      <div className={cn('inline-flex items-baseline gap-2', className)}>
        <img
          src="/images/logos/sr.svg"
          alt="Saudi Riyal"
          className={cn('h-5 w-5 object-contain', iconClassName)}
        />
        <span className={cn('', textClassName)}>
          {formatCurrency(amount, { currency, showSymbol: false })}
        </span>
      </div>
    )
  }

  return (
    <span className={cn(className, textClassName)}>
      {formatCurrency(amount, { currency })}
    </span>
  )
}

export default CurrencyAmount


